import { Observable, SubscribableOrNullableValue } from 'knockout';

export interface SurveyStatisticsConfig {
    TopicId?: SubscribableOrNullableValue<string>
    FilterData?: any
    Theme?: string
}

export default class SurveyStatisticsModel {
    isSpecialItem = true;
    isSurveyStatistics = true;

    ready = ko.observable(false);

    topicId: Observable<string | undefined>
    filterData: Observable<any | null>
    theme: Observable<string>

    constructor(config: SurveyStatisticsConfig = {}) {
        this.topicId = ko.observable(config.TopicId).unwrap();
        this.filterData = ko.observable(config.FilterData).default(null);

        this.theme = ko.observable(config.Theme).default('classic');
    }

    reset() {
        this.ready(false);
    }
}